import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow7",
  "use": "icon-arrow7-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow7\"><path d=\"M360.512 798.08a42.56 42.56 0 0 1 0-60.16L586.432 512l-225.92-225.92a42.56 42.56 0 1 1 60.16-60.16l233.408 233.344a74.56 74.56 0 0 1 0 105.472L420.736 798.08c-16.64 16.64-43.52 16.64-60.16 0z\" p-id=\"8449\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol